import * as React from 'react';
import { useState } from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import { useLogin, useNotify } from 'react-admin';
import './LoginPage.css';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const notify = useNotify();
  const login = useLogin();

  const buttonStyle = { width: '70%', maxWidth: '380px', display: 'block', margin: '0 auto' };

  const handleSubmit = (e) => {
    e.preventDefault();
    login({ email, password })
      .catch((error) => {
        // check if the error has a message from the response
        const errorMessage = error.message || 'Invalid email or password';
        // display the error message
        notify(errorMessage);
      });
  };


  return (
    <div className="login-container d-flex justify-content-center align-items-center min-vh-100">
      <div className="login-card p-5 bg-white rounded shadow-lg">
        <form className="Auth-form" onSubmit={handleSubmit}>
          <h3 className="Auth-form-title text-center mb-4">Welcome Back</h3>

          <div className="form-group mb-3">
            <label htmlFor="email" className="form-label">Email Address</label>
            <input
              id="email"
              type="email"
              required
              className="form-control form-control-lg"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className="form-group mb-4">
            <label htmlFor="password" className="form-label">Password</label>
            <input
              id="password"
              type="password"
              className="form-control form-control-lg"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button
            type="submit"
            className="btn btn-primary btn-lg text-white fw-bold rounded-pill px-5 shadow mb-4"
            style={buttonStyle}
          >
            Log In
          </button>

          <div className="text-center" style={{ width: '100%' }}>
            <a
              href="https://portal.wmca.org.uk/public/forgotpassword"
              className="btn btn-warning btn-lg text-white fw-bold rounded-pill px-5 shadow mb-3"
              style={{
                ...buttonStyle,
                fontSize: '1rem',
                textTransform: 'uppercase',
              }}
            >
              Forgot Password?
            </a>

            <br />
            <p className="mb-1 text-muted fw-bold" style={{ fontSize: '1.1rem' }}>New Portal Account?</p>
            <a
              href="https://portal.wmca.org.uk/public/register"
              className="btn btn-primary btn-lg text-white fw-bold rounded-pill px-5 shadow mb-3"
              style={buttonStyle}
            >
              Register for Portal
            </a>

          </div>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
